module.exports = __webpack_public_path__ + "static/media/reactlogo.fb0bc8ea.png";